module.exports = __webpack_public_path__ + "static/media/profile-8-selected.e0cfae79.png";